import React from 'react';
import { IconProps } from '../types';

export const B2BMarketingIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_9520_39649)">
            <path
                d="M24 8.00004V1.33337H8V12"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M13.3334 30.6667H18.6667"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M30.6667 12H18.6667V30.6667H30.6667V12Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path d="M24 17.3334H25.3333" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
            <path
                d="M12.6667 6.66675H18.0001"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path d="M18 6.66675H19.3333" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
            <path d="M24 21.3334H25.3333" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
            <path d="M24 25.3334H25.3333" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
            <path
                d="M6.99192 25.8126L7.88021 27.6159C8.17414 28.2744 7.87859 29.0457 7.22009 29.3397C6.56159 29.6336 5.79023 29.338 5.4963 28.6795L3.01819 23.332"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M13.5128 26.2948L7.01709 23.3261H3.76925C2.42383 23.3261 1.33337 22.2016 1.33337 20.8141C1.33337 19.4266 2.42383 18.3021 3.76925 18.3021H7.01709L13.5128 15.3334V26.2948Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
        </g>
        <defs>
            <clipPath id="clip0_9520_39649">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
